{
  "Quoter": {
    "QuoteError": "No se pudo obtener la cotización"
  }
}